import { createGlobalStyle } from 'styled-components';
import 'react-circular-progressbar/dist/styles.css';

export default createGlobalStyle`

  /**
  *  Responsividade
  ## CSS Units  ( Unidades de medidas do CSS)

  ### Layout Fixo
  px - Pixels

  ### Layout Responsivo
  % - Porcentagem
  auto - Automática
  vh - Viewport Height
  vw - Viewport Weidh

  ### Texto Fixos
  1px = 0.75pt
  16px = 12pt

  ### Texto Responsivos
  em = Multiplicado pelo Pai (cuidado pode ocorrencer em cascata)
  rme = Multiplicado pelo Root  (font-size: 62.5%; A cada 1rem será considerado 10px )

  # Media queries
  @media (max-width: 768px) {} será aplicado de 0 <= 768px
  @media (min-width: 768px) {} será aplicado de >= 768px

  */

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  html {
    min-height: 100vh;
    /* a cada 1rem será considerado 10px */
    font-size: 62.5%;
  }


  body, input , button {
    font: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 1.6rem;
    transition: color .2s ease-out;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }



  h1, h2, h3, h4, h5, h6, strong {
    font-weight: 500;
  }

  button {
    cursor: pointer;
  }

  :root {
    --enable: #28a745;
    --disable: #b2bac7;
    --error: #c53030;
    --background-text-error: #fff;

    /* PALETA AGUA VIVA - Inspirada nos tons azuis translúcidos das águas-vivas */
    --primary: #4fc3f7;          /* Azul água-viva principal */
    --primary-hover: #29b6f6;    /* Azul mais vibrante no hover */
    --primary-light: #81d4fa;    /* Azul claro translúcido */
    --primary-text: #fff;
    --success: #28a745;
    --danger: #dc3545;

    --button-text: #fff;
    --button-blue: #007bff;
    --button-blue-hover: #0069d9;
    --button-blue-border: #0062cc;
    --button-primary: #4fc3f7;
    --button-primary-hover: #29b6f6;
    --button-primary-border: #0288d1;
    --button-secondary: #6c757d;
    --button-secondary-hover: #5a6268;
    --button-secondary-border: #545b62;
    --button-success: #28a745;
    --button-success-hover: #218838;
    --button-success-border: #1e7e34;
    --button-warning: #ffc107;
    --button-warning-hover: #e0a800;
    --button-warning-border: #d39e00;
    --button-danger: #dc3545;
    --button-danger-hover: #c82333;
    --button-danger-border: #bd2130;
    --button-info: #17a2b8;
    --button-info-hover: #138496;
    --button-info-border: #117a8b;
    --button-light: #f8f9fa;
    --button-light-hover: #e2e6ea;
    --button-light-border: #dae0e5;
    --button-dark: #343a40;
    --button-dark-hover: #23272b;
    --button-dark-border: #1d2124;

  }

  body.light-theme {

    /** Global */
    --background: #f0f9ff;        /* Fundo azul muito claro, como água cristalina */
    --text: #1e3a8a;              /* Texto azul escuro */
    --placeholder: #64748b;       /* Placeholder azul acinzentado */
    --border: #e0f2fe;           /* Bordas azul claríssimo */
    --backgroun-icon-hover: rgba(79, 195, 247, 0.1);

    /** PopupMenu */
    --color-popoup-menu-hover: #4fc3f7;

    /** Loader */
    --border-loading-active: #4fc3f7;
    --border-loading: #e0f2fe;

    /** Header */
    --background-header: #4fc3f7;
    --text-header: #fff;

    /** SideBar */
    --background-sidebar: #fff;
    --text-item-menu: #1e3a8a;
    --backgrount-item-menu-hover: #e0f7ff;  /* Hover azul muito suave */
    --text-item-menu-hover: #4fc3f7;
    --link-active-sidebar: #4fc3f7;
    --link-border-active-sidebar: #4fc3f7;

    /** SubMenu */
    --background-color-submenu: #f0f9ff;

    /** Header Pages */
    --background-header-icon: #fff;
    --background-header-text: #fff;
    --background-header-page-1: #4fc3f7;
    --background-header-page-2: #29b6f6;

    /** PANEL */
    --background-panel: #fff;

    /** TABLE */
    --border-table: #e0f2fe;

    /** PAGINATION */
    --background-pagination-icon-hover: rgba(79, 195, 247, 0.04);
    --background-pagination-icon-disabled: #e0f2fe;
    --background-pagination-icon-enabled: #1e3a8a;

    /** Input */
    --background-input: #fff;
    --border-input: #64748b;
    --selected-input: #4fc3f7;

    /** Link */
    --link: #4fc3f7;
    --link-hover: #29b6f6;

     /** PDF View */
    --pdf-header: rgba(30, 58, 138, 1);     /* Azul escuro para header do PDF */
    --pdf-header-button-hover: rgba(148, 163, 184, 1);

  }

  body.dark-theme {

    /** Global */
    --background: #0c1426;        /* Fundo escuro azul profundo como oceano noturno */
    --text: #94a3b8;              /* Texto azul acinzentado claro */
    --placeholder: #475569;       /* Placeholder mais escuro */
    --border: #334155;           /* Bordas azul escuro */
    --backgroun-icon-hover: rgba(79, 195, 247, 0.3);

    /** Loader */
    --border-loading-active: #4fc3f7;
    --border-loading: #334155;

    /** Header */
    --background-header: #1e293b;  /* Header azul escuro */
    --text-header: #fff;

    /** SideBar */
    --background-sidebar: #1e293b; /* Sidebar azul escuro */
    --text-item-menu: #64748b;     /* Texto dos itens em azul acinzentado */
    --backgrount-item-menu-hover: rgba(79, 195, 247, 0.1);
    --text-item-menu-hover: #4fc3f7;
    --link-active-sidebar: #4fc3f7;
    --link-border-active-sidebar: #4fc3f7;

    /** SubMenu */
    --background-color-submenu: #0c1426;

    /** Header Pages */
    --background-header-icon: #fff;
    --background-header-text: #fff;
    --background-header-page-1: #4fc3f7;
    --background-header-page-2: #29b6f6;

    /** PANEL */
    --background-panel: #1e293b;

    /** TABLE */
    --border-table: #334155;

    /** PAGINATION */
    --background-pagination-icon-hover: #1e293b;
    --background-pagination-icon-disabled: #334155;
    --background-pagination-icon-enabled: #fff;

    /** Input */
    --background-input: #0f172a;    /* Input com fundo azul muito escuro */
    --border-input: #334155;
    --selected-input: #4fc3f7;

     /** Link */
     --link: #4fc3f7;
     --link-hover: #29b6f6;

     /** PDF View */
     --pdf-header: rgba(15, 23, 42, 1);      /* PDF header azul profundo */
     --pdf-header-button-hover: rgba(148, 163, 184, 1);

  }

  body {
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    background: var(--background);
    color: var(--text);
    -webkit-font-smoothing: antialiased;
  }

  /** Route active SideBarMenu */
  .sideBarLinkActive  span,
  .sideBarLinkActive  svg {
    color: var(--link-active-sidebar) !important;
    font-weight: 700;
  }

  /** HELPERS */

  .text-left {
    text-align: left;
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }

  /* for custom scrollbar for webkit browser*/
/*
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}
::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
} */

/* Customize website's scrollbar like Mac OS - Tema Agua Viva
Not supports in Firefox and IE */

/* total width */
::-webkit-scrollbar {
    background-color: var(--background);
    width:16px
}

/* background of the scrollbar except button or resizer */
::-webkit-scrollbar-track {
    background-color: var(--background);
}
::-webkit-scrollbar-track:hover {
    background-color: var(--border);
}

/* scrollbar itself */
::-webkit-scrollbar-thumb {
    background-color: #81d4fa;      /* Tom azul suave da água-viva */
    border-radius:16px;
    border:5px solid var(--background);
}
::-webkit-scrollbar-thumb:hover {
    background-color: #4fc3f7;      /* Azul mais vibrante no hover */
    border:4px solid var(--border);
}

/* set button(top and bottom of the scrollbar) */
::-webkit-scrollbar-button {display:none}



`;
